import { WarehousesResponseModel } from "../pages/shared/models/api/warehouses-response.model";
import { WarehouseModel } from "../pages/shared/models/order/warehouse.model";
import { CountryModel } from "../pages/shared/models/countryModel";
import axiosInstance from "../router/interceptor";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4001/bls";

async function getWarehouses(page?: number, limit?: number) {
  try {
    const authorizationHeader = configAuthorizationHeader();

    const params = new URLSearchParams();

    if (limit) {
      params.append("limit", "" + limit);
    }
    params.append("page", "" + (page || 0));

    return axiosInstance
      .get(`${API_URL}/warehouses`, { params, ...authorizationHeader })
      .then((response) => {
        return response?.data as WarehousesResponseModel;
      });
  } catch (error) {
    console.error(error);

    return {
      currentPage: 0,
      warehouses: [],
      pageSize: 0,
      totalItems: 0,
    } as WarehousesResponseModel;
  }
}

async function getWarehouseById(warehouseId: number) {
  try {
    const authorizationHeader = configAuthorizationHeader();
    return axiosInstance.get(
      `${API_URL}/warehouses/${warehouseId}`,
      authorizationHeader,
    );
  } catch (error) {
    console.error(error);
  }
}

async function createWarehouse(
  country: CountryModel,
  warehouse: WarehouseModel,
) {
  try {
    const authorizationHeader = configAuthorizationHeader();
    const body = {
      country: country.countryId,
      warehouse,
    };
    return axiosInstance
      .post(`${API_URL}/warehouses/create`, body, authorizationHeader)
      .then((response) => response?.data as WarehouseUpdateMeta);
  } catch (error) {
    console.error(error);

    return {
      acknowledged: false,
      matchedCount: 0,
      modifiedCount: 0,
      upsertedCount: 0,
      upsertedId: 0,
    } as WarehouseUpdateMeta;
  }
}

async function editWarehouse(
  warehouseId: number,
  warehouse: { [key: string]: any },
) {
  try {
    const authorizationHeader = configAuthorizationHeader();

    delete warehouse.warehouseId;

    return axiosInstance
      .put(
        `${API_URL}/warehouses/${warehouseId}`,
        warehouse,
        authorizationHeader,
      )
      .then((response) => response?.data as WarehouseUpdateMeta);
  } catch (error) {
    console.error(error);

    return {
      acknowledged: false,
      matchedCount: 0,
      modifiedCount: 0,
      upsertedCount: 0,
      upsertedId: 0,
    } as WarehouseUpdateMeta;
  }
}

function configAuthorizationHeader() {
  let token = localStorage.getItem("access_token");
  const refreshToken = localStorage.getItem("refresh_token");
  token = token ? token.replaceAll('"', "") : "";
  return {
    headers: {
      Authorization: "Bearer ".concat(token),
      "x-refresh-token": refreshToken,
    },
  };
}

export interface WarehouseUpdateMeta {
  acknowledged: boolean;
  matchedCount: number;
  modifiedCount: number;
  upsertedCount: number;
  upsertedId: number;
}

export default {
  getWarehouses,
  getWarehouseById,
  createWarehouse,
  editWarehouse,
};
